import Api from '@/api/api.js'

export default {

    /**
     * Situations matrimonial
     */
    getSituationsMatrimoniales () {
        const promise = Api().get('/situations-matrimoniales')
        return promise.then((response) => response.data)
    },

    /**
     * Sexes
     */
    getSexes () {
        const promise = Api().get('/sexes')
        return promise.then((response) => response.data)
    },

    /**
     * Assurances
     */
    getAssurances () {
        const promise = Api().get('/assurances') 
        return promise.then((response) => response.data)
    },

    /**
     * Civilites
     */
    getCivilites () {
        const promise = Api().get('/civilites') 
        return promise.then((response) => response.data)
    },

     /**
     * Professions
     */
    getProfessions () {
        const promise = Api().get('/professions') 
        return promise.then((response) => response.data)
    },
  

  }